module.exports = __webpack_public_path__ + "static/img/upload-sucess.1130ab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/upload-sucess.jpg
// module id = BgwU
// module chunks = 1